export const environment = {
  production: false,
  storagePrefix: 'NEXPE_QA',
  ssoRedirectUri: 'https://hml-modulo.credimorar.com.vc/autenticacao',
  ssoClientKey: 'OXotnGPiEW_60NoNLAAK88mbQe0b',
  ssoServerUrl: 'https://hml-bpo.credimorar.me',
  apis: {
    // contracts: {
    //   baseUrl: 'https://usvlcrd02rn016.azurewebsites.net/api',
    //   microservices: {
    //     contract: 'Contract',
    //     report: 'v1/Report',
    //     params: 'Parameter'
    //   }
    // },
    // transfers: {
    //   baseUrl: 'https://usvlcrd02rn018.azurewebsites.net/api',
    //   microservices: {
    //     report: 'v1/Report',
    //     batch: 'v1/Batch',
    //     batchConfig: 'v1/BatchConfig',
    //     storeConfig: 'StoreConfig',
    //     economicGroup: 'EconomigGroup',
    //     reversalParameter: 'ReversalParamter'
    //   }
    // },
    // invoices: {
    //   baseUrl: 'https://usvlcrd02rn017.azurewebsites.net/api',
    //   microservices: {
    //     report: 'v1/Report',
    //     batch: 'v1/Batch',
    //     commission: 'Commission'
    //   }
    // },
    notification: {
      baseUrl: 'https://usvlcrd02rn019.azurewebsites.net/api',
      microservices: {
        template: 'v1/Template'
      }
    },
    unified: {
      baseUrl: 'https://usvlcrd02rn005.azurewebsites.net/api',
      microservices: {
        contract: 'contract-contract',
        contractReport: "contract-report",
        contractParameter: 'contract-parameter',

        invoiceBatch: 'invoice-batch',
        invoiceReport: "invoice-report",
        invoiceCommission: "invoice-commission",
        invoiceContract: "invoice-contract",        

        transferReport: "transfer-report",
        transferBatch: "transfer-batch",
        transferBatchConfig: "transfer-batch-config",
        transferEconomicGroup: "transfer-economig-group",
        transferStoreConfig: "transfer-storeConfig",
        transferReversalParamter: "transfer-reversal-paramter"
      }
    }
  }
};
